import { DocumentType } from '../../../pages/hospital/Billing/types';

export type BillPdfLayoutVariant = 'default' | 'summaryCompact';

/** Spacing and typography preset for bill PDF documents (SHER-425). */
export interface BillPdfLayout {
    variant: BillPdfLayoutVariant;
    page: {
        paddingTop: number;
        paddingLeft: number;
        paddingRight: number;
        paddingBottomWithMetadata: number;
    };
    header: {
        logoWidth: number;
        logoHeight: number;
        marginBottom: number;
        dateMarginTop: number;
        titleStyle: 'h3' | 'h4';
        titleMarginTop: number;
    };
    patientInfoMarginBottom: number;
    statusBanner: { paddingVertical: number; marginBottom: number };
    subtitleMarginBottom: number;
    prelude: { marginBottom: number; detailMarginTop: number; wrap: boolean };
    billFormTitle: { style: 'h4' | 'body2'; marginTop: number };
    table: { marginTop: number; rowPadding: number; compact: boolean };
    footer: { marginTop: number; signatureWidth: string };
}

export const billPdfLayouts: Record<BillPdfLayoutVariant, BillPdfLayout> = {
    default: {
        variant: 'default',
        page: {
            paddingTop: 30,
            paddingLeft: 30,
            paddingRight: 30,
            paddingBottomWithMetadata: 85,
        },
        header: {
            logoWidth: 200,
            logoHeight: 100,
            marginBottom: 12,
            dateMarginTop: 16,
            titleStyle: 'h3',
            titleMarginTop: 2,
        },
        patientInfoMarginBottom: 5,
        statusBanner: { paddingVertical: 4, marginBottom: 8 },
        subtitleMarginBottom: 10,
        prelude: { marginBottom: 10, detailMarginTop: 10, wrap: true },
        billFormTitle: { style: 'h4', marginTop: 10 },
        table: { marginTop: 10, rowPadding: 3, compact: false },
        footer: { marginTop: 20, signatureWidth: '45%' },
    },
    summaryCompact: {
        variant: 'summaryCompact',
        page: {
            paddingTop: 22,
            paddingLeft: 24,
            paddingRight: 24,
            paddingBottomWithMetadata: 62,
        },
        header: {
            logoWidth: 130,
            logoHeight: 65,
            marginBottom: 4,
            dateMarginTop: 6,
            titleStyle: 'h4',
            titleMarginTop: 0,
        },
        patientInfoMarginBottom: 3,
        statusBanner: { paddingVertical: 2, marginBottom: 4 },
        subtitleMarginBottom: 4,
        prelude: { marginBottom: 4, detailMarginTop: 2, wrap: false },
        billFormTitle: { style: 'body2', marginTop: 4 },
        table: { marginTop: 4, rowPadding: 1, compact: true },
        footer: { marginTop: 6, signatureWidth: '35%' },
    },
};

export function billPdfLayoutForDocumentType(type: DocumentType): BillPdfLayout {
    return type === DocumentType.SUMMARY ? billPdfLayouts.summaryCompact : billPdfLayouts.default;
}
